import createFlashMessage from '../actions/FlashMessages/createFlashMessage'

export const isErrorAction = (action) => {
  const { type } = action
  if (!type) return false
  return type.endsWith('_ERROR')
}

export const formatResourceErrors = (resourceErrors) => {
  if (!resourceErrors || typeof resourceErrors !== 'object') {
    return ''
  }

  const messages = Object.entries(resourceErrors).map(([field, errors]) => {
    if (Array.isArray(errors)) {
      return `${field} ${errors.join(', ')}`
    }
    return `${field} ${errors}`
  })

  return messages.join('; ')
}

export const formatErrorMessage = (action) => {
  if (action.generalError) {
    return action.generalError
  }

  if (action.resourceErrors) {
    const formatted = formatResourceErrors(action.resourceErrors)
    if (formatted) return formatted
  }

  return 'An error occurred'
}

const apiErrorMiddleware = (store) => (next) => (action) => {
  if (isErrorAction(action)) {
    const message = formatErrorMessage(action)
    store.dispatch(createFlashMessage(message, {
      tag: 'general',
      type: 'alert',
      autoDismiss: false
    }))
  }

  return next(action)
}

export default apiErrorMiddleware
